









































import { Component, Prop } from 'vue-property-decorator';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import DepositAccount from '@/models/Accounts/DepositAccounts/DepositAccount';
import LendingAccount from '@/models/Accounts/LendingAccounts/LendingAccount';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import AdjustmentTool from '@/components/Accounts/Shared/Toolkit/AdjustmentTool.vue';
import RollForwardDatesTool from '@/components/Accounts/Shared/Toolkit/RollForwardDatesTool.vue';
import SimulationModeTool from '@/components/Accounts/Shared/Toolkit/SimulationModeTool.vue';
import NewSimulationTool from '@/components/Accounts/Shared/Toolkit/NewSimulationTool.vue';
import ProductType from "@/models/Products/ProductType";
import ProductSubType from "@/models/Products/ProductSubType";
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'AccountToolkitMenu', components: { AdjustmentTool, RollForwardDatesTool, SimulationModeTool, NewSimulationTool } })
export default class extends SaascadaVue {

    @Prop({required: true})
    account: DepositAccount | LendingAccount;

    get atLeastOneToolIsAvailable() {
        return this.allowAdjustmentTool || this.allowRollForwardDatesTool || this.allowSimulationModeTool;
    }

    get allowAdjustmentTool() {
        // This tool is only allowed for deposit accounts and when the feature toggle is enabled (which should be controlled per environment)
        const isDepositAccount = this.account.productType === ProductType.Deposit;
        return isDepositAccount && PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.AccountToolkit);
    }

    get allowSimulationModeTool() {
        // This tool is only allowed for lending accounts
        return this.account.productType === ProductType.Lending;
    }

    get allowNewSimulationTool() {
        // This tool is only allowed for lending accounts and when simulation mode is enabled
        return this.account.productType === ProductType.Lending && LendingAccountModule.simulationModeEnabled;
    }

    get allowRollForwardDatesTool() {
        // This tool is only allowed for deposit fixed term products and when the feature toggle is enabled (which should be controlled per environment)
        const isFixedTermAccount = this.account.productSubType === ProductSubType.DepositFixedTerm;
        return isFixedTermAccount && PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.AccountToolkit);
    }

};
